import { OnDestroy, OnInit } from '@angular/core';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(settingsService, authService, router) {
        this.settingsService = settingsService;
        this.authService = authService;
        this.router = router;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.stream = this.authService.canActivateProtectedRoutes$.subscribe(function (yes) {
            if (yes)
                _this.router.navigate(['/home']);
        });
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        this.stream.unsubscribe();
    };
    LoginComponent.prototype.login = function () {
        this.authService.login('/login-callback');
    };
    return LoginComponent;
}());
export { LoginComponent };
